export default "__VITE_ASSET__Dp77we8G__"